import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { VulnerabilitiesAppWebComponentSchema } from '../types';

export class VulnerabilitiesAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<VulnerabilitiesAppWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
